<script setup lang="ts">
	interface NavigationSubSubItem {
		label: string,
		name: string,
		slug: string,
		title: string,
	}
	interface NavigationSubItem {
		label: string,
		name: string,
		slug: string,
		icon: string,
		title: string,
		txtColorCls: string,
		bgColorCls: string,
		borderColorCls: string,
		hoverColorCls: string,
		children: Array<NavigationSubSubItem>
	}
	interface NavigationItem {
		label: string,
		name: string,
		slug?: string,
		title: string,
		children?: Array<NavigationSubItem>
	}

	export type {
		NavigationSubItem,
		NavigationItem
	}

	const { items, isScrolled = false } = defineProps<{
		items: Array<NavigationItem>,
		isScrolled: boolean
	}>()
</script>

<template>
	<nav v-if="items?.length" role="navigation" class="hidden @6xl:block my-auto inline-flex justify-center items-center gap-[15px]" :class="{'py-3 bg-white rounded-xl shadow-[0px_2px_8.100000381469727px_0px_rgba(0,0,0,0.13)] ':!isScrolled}">
		<span class="flex flex-row justify-end lg:space-x-2 xl:space-x-3 mx-5">
			<span v-for="(item,idx) in items" :key="idx" class="leading-none relative">
				<NuxtLink v-if="item.name" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" class="px-3 py-1.5 rounded-xl font-medium lg:text-[1.125rem] xl:text-[1.25rem] text-tuatara-900 hover:!text-white hover:bg-yellow-sea-500 whitespace-nowrap transition duration-500 ease-in-out" :title="item.title" :class="{'2xl:!text-[20px]':isScrolled}" no-prefetch>{{ item.label }}</NuxtLink>
				<NavigationSubMega v-else :item="item" :isScrolled="isScrolled" :key="'sub-'+idx" />
			</span>
		</span>
	</nav>
</template>
